var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "34px",
    viewBox: "0 0 35 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WHT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-7.4%",
    y: "-7.4%",
    width: "117.6%",
    height: "114.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.001235%",
    y1: "100%",
    x2: "50.001235%",
    y2: "5.24785989e-15%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60D66A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9999977%",
    y1: "100%",
    x2: "49.9999977%",
    y2: "2.36419771e-14%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Home",
    transform: "translate(-1472.000000, -500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1445.000000, 481.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WHT",
    filter: "url(#filter-1)",
    transform: "translate(27.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape_4",
    transform: "translate(1.172414, 1.172414)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.520400445,31.8788982 L2.7585762,23.7262582 C1.37531879,21.3330152 0.648958661,18.6180302 0.652769744,15.8551863 C0.652769744,7.17413446 7.73263626,0.116816763 16.428921,0.116816763 C20.6140652,0.117016629 24.6276286,1.77681873 27.5862631,4.73091593 C30.5448975,7.68501312 32.2061218,11.6912962 32.2043159,15.8680191 C32.2043159,24.549071 25.1229366,31.6071436 16.428921,31.6071436 L16.4221135,31.6071436 C13.7884583,31.6069449 11.1968171,30.9482704 8.88387097,29.6912732 L0.520400445,31.8788982 Z M9.27114572,26.8408687 L9.74994438,27.1239464 C11.7704305,28.3180065 14.0754571,28.9479214 16.4236263,28.9477222 L16.428921,28.9477222 C23.6555284,28.9477222 29.53802,23.0793312 29.5410456,15.8657545 C29.5422495,12.3951999 28.1619519,9.06631289 25.7038026,6.61141078 C23.2456533,4.15650867 19.9110111,2.77668427 16.4334594,2.77548324 C9.20080089,2.77548324 3.31906563,8.64311941 3.31604004,15.8559412 C3.31241714,18.318721 4.00735191,20.7322281 5.32048943,22.8173899 L5.63288098,23.3125872 L4.31145717,28.1400069 L9.27114572,26.8408687 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.24120133,32.5017637 L4.40222469,24.6284271 C3.06725352,22.3189638 2.36595675,19.6990791 2.36903226,17.0328842 C2.36903226,8.653782 9.20458287,1.83953375 17.5983092,1.83953375 C21.6383517,1.83973375 25.5127786,3.44190713 28.3689525,6.29346683 C31.2251265,9.14502653 32.8289907,13.0122939 32.8275862,17.0442073 C32.8275862,25.4233095 25.9920356,32.2383126 17.5983092,32.2383126 L17.5915017,32.2383126 C15.049061,32.2378806 12.5472034,31.6020612 10.3142158,30.3888712 L2.24120133,32.5017637 Z",
    id: "shape_3",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shape_2",
    transform: "translate(0.718576, 0.412822)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.974238042,32.6384903 L3.21241379,24.4858503 C1.82915639,22.0926072 1.10279626,19.3776223 1.10660734,16.6147783 C1.10660734,7.9337265 8.18647386,0.876408798 16.8827586,0.876408798 C21.0679028,0.876608664 25.0814662,2.53641077 28.0401007,5.49050796 C30.9987351,8.44460515 32.6599594,12.4508882 32.6581535,16.6276112 C32.6581535,25.308663 25.5767742,32.3667356 16.8827586,32.3667356 L16.8759511,32.3667356 C14.2422959,32.366537 11.6506547,31.7078624 9.33770857,30.4508652 L0.974238042,32.6384903 Z M9.72498331,27.6004607 L10.203782,27.8835385 C12.2242681,29.0775985 14.5292947,29.7075134 16.8774638,29.7073142 L16.8827586,29.7073142 C24.109366,29.7073142 29.9918576,23.8389232 29.9948832,16.6253466 C29.9960871,13.1547919 28.6157895,9.82590493 26.1576402,7.37100282 C23.6994909,4.9161007 20.3648487,3.5362763 16.887297,3.53507528 C9.65463849,3.53507528 3.77290323,9.40271144 3.76987764,16.6155332 C3.76625474,19.0783131 4.46118951,21.4918201 5.77432703,23.5769819 L6.08671858,24.0721793 L4.76529477,28.899599 L9.72498331,27.6004607 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape_1",
    transform: "translate(8.660734, 8.942899)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99750834,1.5052189 C4.7025139,0.849988205 4.39239155,0.837155346 4.11025584,0.825832235 C3.88333704,0.816018872 3.61784205,0.816773746 3.35385984,0.816773746 C2.94995245,0.827309839 2.5688115,1.0057299 2.30246941,1.30895164 C1.94091212,1.70224103 0.922803115,2.65413724 0.922803115,4.58963436 C0.922803115,6.52513148 2.33575083,8.39570943 2.53241379,8.65840561 C2.72907675,8.92110178 5.25922136,13.0193131 9.26433815,14.5962451 C12.5924805,15.9067064 13.2732369,15.6462749 13.9948387,15.5775814 C14.7164405,15.5088878 16.3268076,14.62644 16.6558398,13.7077583 C16.9848721,12.7890765 16.9841157,12.0017429 16.8827586,11.8371803 C16.7814016,11.6726178 16.5212013,11.575239 16.1263626,11.3782169 C15.7315239,11.1811948 13.7943938,10.2292985 13.4328365,10.094931 C13.0712792,9.96056338 12.8088098,9.89790883 12.545584,10.2919531 C12.2823582,10.6859974 11.527475,11.5714646 11.2975306,11.833406 C11.0675862,12.0953473 10.8376418,12.1293166 10.4435595,11.9322945 C10.0494772,11.7352723 8.77948832,11.3200916 7.27350389,9.98019011 C6.1018465,8.93770901 5.3068743,7.64989385 5.07995551,7.25584958 C4.85303671,6.86180531 5.05499444,6.65195032 5.25317019,6.45341844 C5.43016685,6.27753278 5.6472525,5.99445501 5.84467186,5.76421841 C6.04209121,5.53398182 6.10714127,5.37092902 6.23875417,5.10823285 C6.37036707,4.84553667 6.30456062,4.61605495 6.20622914,4.41903282 C6.10789766,4.22201068 5.34771969,2.28273919 4.99750834,1.5052189 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhats);
export default __webpack_public_path__ + "static/media/whats.71eec2c5f91e96bfd32d9127f49d3bce.svg";
export { ForwardRef as ReactComponent };